import * as React from "react"; 
import { css } from '@emotion/core';

const Overlay = (props) => {
  let opacity = props.opacity ? props.opacity.toString() : "0.2";
  let bg = `rgba(0, 0, 0, ${opacity})`;

  let style = css`
    position: absolute;
    display: block;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: ${bg};
    z-index: 2;
  `; 

  return <div css={style}></div>;
};

export default Overlay;